export enum GENDER_NAME {
    Male = 'Masculino',
    Female = 'Femenino'
}